import { gql } from '@apollo/client';
export const CLIENT_FIELDS = gql `
  fragment ClientFields on Client {
    id
    code
    name
    employerId
    createdAt
    updatedAt
    logoS3Key
    isParent
    parentId
    clientConfig {
      locale
      currency
      country
      timezone
    }
  }
`;
export const CLIENTS = gql `
  ${CLIENT_FIELDS}
  query CLIENTS($spec: ClientSpec!) {
    clients(spec: $spec) {
      total
      page
      pageSize
      items {
        ...ClientFields
      }
    }
  }
`;
export const SAVE_CLIENT = gql `
  ${CLIENT_FIELDS}
  mutation SAVE_CLIENT($input: ClientInput!) {
    saveClient(input: $input) {
      success
      client {
        ...ClientFields
      }
      messages {
        value
        type
        params
      }
    }
  }
`;
export const ADD_CHILD_CLIENTS = gql `
  mutation ADD_CHILD_CLIENTS($input: AddChildClientsInput!) {
    addChildClients(input: $input) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
export const REMOVE_CLIENT_FROM_PARENT = gql `
  mutation REMOVE_CLIENT_FROM_PARENT($clientId: Int!) {
    removeClientFromParent(clientId: $clientId) {
      messages {
        value
        type
      }
    }
  }
`;
